export const allMunicipalities = [
    {
        mpc_id: '',
        title: 'सबै स्थानिय सरकारहरु',
        titleEn: 'All Municipalities',
    },
    {
        mpc_id: 5,
        title: 'साँफेबगर',
        titleEn: 'Sanfebagar',
    },
    {
        mpc_id: 8,
        title: 'मष्टा',
        titleEn: 'Masta',
    },
    {
        title: 'कोन्ज्योसोम',
        titleEn: 'Konjyosom',
        mpc_id: 12,
    },
    {
        title: 'बागमति',
        titleEn: 'Bagmati',
        mpc_id: 11,
    },
    {
        title: 'बाह्रविसे',
        titleEn: 'Barhabise',
        mpc_id: 9,
    },
    {
        title: 'सुनकाेशी',
        titleEn: 'Sunkoshi',
        mpc_id: 10,
    },
    {
        title: 'अमरगढी',
        titleEn: 'Amargadhi',
        mpc_id: 3,
    },
    {
        title: 'नवदूर्गा',
        titleEn: 'Nawadurga',
        mpc_id: 4,
    },
    {
        title: 'धनगढी',
        titleEn: 'Dhangadhi',
        mpc_id: 2,
    },
    {
        title: 'कैलारी',
        titleEn: 'Kailari',
        mpc_id: 1,
    },
    {
        title: 'बान्नीगढी जयगढ',
        titleEn: 'Bannigadhi Jayagadh',
        mpc_id: 6,
    },
    {
        title: 'जयपृथ्वी',
        titleEn: 'Jaya Prithvi',
        mpc_id: 7,
    },
    {
        title: 'मेल्लेख',
        titleEn: 'Mellekh',
        mpc_id: 14,
    },
    {
        title: 'अजयमेरु',
        titleEn: 'Ajayameru',
        mpc_id: 15,
    },
    {
        title: 'जुगल',
        titleEn: 'Jugal',
        mpc_id: 16,
    },
    {
        title: 'चौरपाटी',
        titleEn: 'Chaurpati',
        mpc_id: 17,
    },
    {
        title: 'दुर्गाथली',
        titleEn: 'Durgathali',
        mpc_id: 18,
    },
    {
        title: 'खप्तडछान्ना',
        titleEn: 'Khaptad Chhanna',
        mpc_id: 19,
    },
    {
        title: 'परशुराम',
        titleEn: 'Parshuram',
        mpc_id: 20,
    },
    {
        title: 'गौरीगंगा',
        titleEn: 'Gauriganga Chhanna',
        mpc_id: 21,
    },
];

export const getMunicipalityFromUrl = () => {
    let currentUrl = window.location.hostname;
    const munNameSearch = decodeURIComponent(new URLSearchParams(window.location.search).get('mun') || '');
    const isSingle = decodeURIComponent(new URLSearchParams(window.location.search).get('isSingle') || '');

    if (isSegregated(currentUrl)) {
        return [allMunicipalities.find(municipality => municipality.titleEn === segregatedMunicipalitiesUrl[currentUrl])];
    }else if(isSingle === 'true' && munNameSearch !== ''){
        return [allMunicipalities.find(municipality => municipality.title === munNameSearch)];
    }else{
        return allMunicipalities;
    }
}

export const isSegregated = (url = window.location.hostname) => {
    return url in segregatedMunicipalitiesUrl;
}

export const getSegregated = (url = window.location.hostname) => {
    return segregatedMunicipalitiesUrl[url];
}

const segregatedMunicipalitiesUrl =  {
    'library.mellekhmun.gov.np': 'Mellekh',
};


// WEBPACK FOOTER //
// ./src/config/subdomains.js